module.exports = __webpack_public_path__ + "static/media/xandzero.32268375.gif";


//////////////////
// WEBPACK FOOTER
// ./src/css/xandzero.gif
// module id = 92
// module chunks = 0